<template>
  <div class="w-100 p-0 m-0">
    <div v-if="profileStrengthSection" class="w-100 text-center" style="position: relative">
      <div class="custom-profile-heading mb-4">
        <span class="custom-underline w-100 pb-2">
          Profile Strength
        </span>
      </div>
      <div class="mt-3 custom-progress-bar">
        <vue-ellipse-progress
          :progress="strengthValue"
          color="#EA216C"
          :thickness="15"
          emptyThickness="8%"
          fontSize="3rem"
          :startAngle="180"
          :endAngle="360"
        >
          <span slot="legend-value">%</span>
        </vue-ellipse-progress>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProfileStrengthComponent",
  props: {
    title: {
      type: String
    },
    profileStrengthSection: {
      type: Boolean
    },
    strengthValue: {
      type: Number,
      required: true,
       strengthValue: {
    type: Number,
    required: true,
    validator: value => {
      console.log('[ProfileStrength] Validating strengthValue:', value);
      
      if (value < 0) {
        console.warn('Profile strength cannot be negative');
        return false;
      }
      
      if (value > 100) {
        console.warn('Profile strength cannot exceed 100%');
        return false;
      }
      
      if (isNaN(value)) {
        console.warn('Profile strength must be a number');
        return false;
      }
      
      return true;
    }
  }
}
}
};
</script>